<template lang="html">
  <div class="article-audio">
    <audio ref="player" :src="source" media-player="audioPlayer"></audio>
    <img class="play" :src="stateIcon" alt="play" @click="handlePlay"/>

    <div class="right">
      <h2>{{title}}</h2>
      <h3>来自{{from}}</h3>

      <div class="progressBar" ref="bar">
        <div class="progress" :style="{width: `${(now / total) * 100}%`}"/>
        <img
          class="block"
          src="../../assets/images/article-audio-progressbar-block.png"
          alt="block"
          :style="{left: `${(now / total) * barWidth}px`}"
          ref="block"/>
      </div>

      <p class="time">
        <span class="now">{{now | formatSeconds(2)}}</span>
        <span class="total">{{total | formatSeconds(2)}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import formatSeconds from '../../filters/format-seconds'

export default {
  name: 'ArticleAudio',

  filters: {
    formatSeconds
  },

  props: ['source', 'title', 'from', 'type'],

  data () {
    return {
      playIcon: require('../../assets/images/article-audio-play.png'),
      playingIcon: require('../../assets/images/article-audio-playing.gif'),
      stateIcon: '',

      playing: false,
      hasPlayed: false,

      now: 0,
      total: 0,

      barWidth: 0,
      barLeft: 0
    }
  },

  methods: {
    handlePlay () {
      if (this.playing) this.pause()
      else this.play()
    },

    play () {
      this.hasPlayed = true
      this.$refs.player.play()
    },

    pause () {
      this.$refs.player.pause()
    },

    getBar () {
      const rect = this.$refs.bar.getBoundingClientRect()
      this.barWidth = rect.width
      this.barLeft = rect.x
    },

    enableBlock () {
      this.$refs.block.addEventListener('touchstart', this.blockMove)
    },

    blockMove ($event) {
      const self = this
      let cache = 0
      this.$refs.block.addEventListener('touchmove', move)

      function move ({ touches: [ $event ]}) {
        self.dragging = true
        self.$refs.block.style.left = Math.min(Math.max(0, ($event.clientX - self.barLeft)), self.barWidth) + 'px'
        self.now = cache = (parseFloat(self.$refs.block.style.left) / self.barWidth) * self.total
      }

      this.$refs.block.addEventListener('touchend', () => {
        this.dragging = false
        this.$refs.player.currentTime = cache
        this.$refs.block.removeEventListener('touchmove', move)
      })
    }
  },

  created () {
    this.stateIcon = this.playIcon
  },

  mounted () {
    this.getBar()
    this.enableBlock()

    this.$refs.player.addEventListener('play', () => {
      this.stateIcon = this.playingIcon
      this.playing = true
    })

    this.$refs.player.addEventListener('pause', () => {
      this.stateIcon = this.playIcon
      this.playing = false
    })

    this.$refs.player.addEventListener('canplay', () => {
      this.total = this.$refs.player.duration
    })

    this.$refs.player.addEventListener('timeupdate', () => {
      !this.dragging && (this.now = this.$refs.player.currentTime)
    })
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

.article-audio {
  position: relative;
  width: rem(686);
  height: rem(184);
  margin: rem(49) 0 rem(57) rem(-13);
  border: rem(1) solid #E6E6E6;
  box-sizing: border-box;
  background-color: #FDFDFD;

  .play {
    position: absolute;
    top: 0; bottom: 0;
    left: rem(40);
    margin: auto;
    height: rem(84);
    width: rem(84);
  }

  .right {
    position: absolute;
    height: 100%;
    left: rem(151);
    width: rem(490);
    padding-top: rem(30);
    box-sizing: border-box;

    h2 {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: rem(30);
      line-height: rem(42);
    }

    h3 {
      color: #999;
      font-size: rem(24);
      line-height: rem(33);
    }

    .progressBar {
      position: relative;
      height: rem(4);
      width: 100%;
      background-color: #EBEBEB;
      margin: rem(13) 0;

      .progress {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 0;
        background-color: #1AAD19;
      }

      .block {
        position: absolute;
        left: 0;
        top: rem(-8);
        height: rem(20);
        width: rem(20);
        margin: 0;
      }
    }

    .time {
      width: 100%;
      color: #999;
      font-size: rem(22);
      line-height: rem(30);

      .now {
        float: left;
      }

      .total {
        float: right;
      }
    }
  }

}
</style>
